import { render } from "./AdminVoiceOfGodSidebar.vue?vue&type=template&id=2a6798a9&scoped=true"
import script from "./AdminVoiceOfGodSidebar.vue?vue&type=script&lang=js"
export * from "./AdminVoiceOfGodSidebar.vue?vue&type=script&lang=js"

import "./AdminVoiceOfGodSidebar.vue?vue&type=style&index=0&id=2a6798a9&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a6798a9"]])

export default __exports__